<template>
  <div class="indexList">
    <search :showChoose="true" :inputAndSelectShow="true" :titleSHow="false" :placeholder1="placeholder1"
      :options="options" @searchBtn="searchBtn" @changeValue="changeValue" @changeTime="changeTime"
      @searchSell="searchSell"></search>
    <div class="allBtn">
      <el-button type="info" plain @click="addBrokerage">佣金已结算</el-button>
    </div>
    <dataTable ref="dataTable" :flush="fresh" :inSerachFilte="inSerachFilte" :inTableData="tableDataConfig"
      :inAjax="tableAjaxConfig" :ispagination="true" @cellClick="cellClick" @rowClick="tableClickConfig"
      @selection="selection"></dataTable>

    <operationDetails ref="detailDialog"></operationDetails>
  </div>
</template>

<script>
import search from "../components/search";
import GlobalUtil from "../../utils/globalUtil";
import operationDetails from '../components/operationDetails'

export default {
  components: {
    search,
    operationDetails
  },
  data() {
    return {
      obj: {},
      // data:'',
      placeholder1: "请选择订单状态",
      options: [
        {
          value: "10",
          label: "待付款"
        },
        {
          value: "11",
          label: "待发货"
        },
        {
          value: "14",
          label: "已完成"
        },
        {
          value: "12",
          label: "已发货"
        },
        {
          value: "13",
          label: "已取消"
        }
      ],
      //用于tableData组件刷新，tableData检测到fresh值发生变化就会刷新数据
      fresh: "",
      // 用于匹配搜索数据，返回新的数据
      inSerachFilte: {},
      //tableData组件参数配置
      tableDataConfig: {
        //表头及字段配置
        tHead: [
          {
            name: "订单编号",
            field: "id"
          },
          {
            name: "商品信息",
            field: "itemName"
          },
          {
            name: "商品状态",
            field: "orderStatus",
            type: "function",
            callback: function (v, row) {
              let obj = {
                11: "<span style='color:rgba(0,138,255,1);'>待发货</span>",
                10: '<span style="color:rgba(251,120,120,1);">待付款</span>',
                13: "<span >已取消</span>",
                12: '<span style="color:rgba(0,189,195,1);">已发货</span>',
                14: '<span style="color:rgba(4,161,85,1);">已完成</span>'
              };
              return obj[v];
            }
          },
          {
            name: "客户名称",
            field: "openIdName",
            type: "function",
            callback: function (v, row) {
              return row.wxUserData.nickName;
            }
          },
          {
            name: "销售人员",
            field: "entMidName"
          },
          {
            name: "分销金额",
            field: "charge"
          },
          {
            name: "下单日期",
            field: "createDate"
          },
          {
            name: "佣金是否结算",
            field: "settlementNot",
            type: "function",
            callback: function (v, row) {
              let type = ''
              if (row.charge == null) {
                type = "未开启分销"
              } else {
                if (row.settlementNot) {
                  type = "已结算"
                } else {
                  type = "未结算"
                }
              }

              return type
            }
          },
          {
            name: "操作",
            type: "actionBtns", //配置操作按钮actionSelectBtns为下拉按钮，actionBtns为平铺按钮
            field: "sendDate",
            callback: function (v, row) {
              let arr = [
                {
                  type: "detail",
                  label: "<span>操作详情</span>"
                }
              ];
              return arr;
            }
          }
        ],
        //自动渲染
        tData: [],
        //自动渲染
        total: 0,
        actionBtWidth: "250",
        //配置是否显示多选框
        isMultiple: true,
        dispatchp: true,
        //配置是否显示排序
        isRank: true
      },
      tableAjaxConfig: {
        url: this.$url.getOrderPage,
        method: "post",
        data: {
          pageNumber: 1,
          pageSize: 15,
          queryObj: {}
        }
      },
    };
  },

  methods: {
    // 操作栏点击事件
    tableClickConfig(data) {
      console.log(data);
      this.$refs.detailDialog.query(data.rowData, 'DDGL')
    },
    // 查询按钮点击事件
    searchBtn(e) {
      console.log(e);

      this.obj['orderOrItemNameOrCustomerNameLike'] = e

      this.inSerachFilte = {
        queryObj: this.obj
      };
    },
    searchSell(e) {
      this.obj['sellingName'] = e
      this.inSerachFilte = {
        queryObj: this.obj
      };
    },
    changeValue(e) {
      if (e) {
        this.obj['orderStatusArr'] = [e]
      } else {
        this.obj['orderStatusArr'] = null
      }

      this.inSerachFilte = {
        queryObj: this.obj
      };
    },
    changeTime(e) {
      console.log(e);
      this.obj['createStartDate'] = e[0]
      this.obj['createEndDate'] = e[1] + 24 * 60 * 60 * 1000 - 1000
      this.inSerachFilte = {
        queryObj: this.obj
      };
    },
    // 整行点击事件
    cellClick(row) {
      console.log(row);
      this.$router.push({
        name: "dingdanlinteam"
      });
      GlobalUtil.setSessionStorage("rowData", row.row);
    },
    // 佣金结算按钮
    addBrokerage() {
      // 获取选中的行数据中的订单 ID 列表
      const selectedOrders = this.rowMessage;
      const orderIdList = selectedOrders.map(order => order.id);

      this.$axios
        .post(this.$url.changeSettlementNot, { orderIdList })
        .then(res => {
          console.log('佣金结算状态更新成功', res);
          this.$message.success('佣金结算状态更新成功');
          // 手动触发表格数据刷新
          this.fresh = Date.now();
        })
        .catch(error => {
          console.error('佣金结算状态更新失败', error);
        });
    },
    // 多选框选中
    selection(data) {
      this.rowMessage = data;
      console.log(this.rowMessage);
    },
  },
  created() {
  }
};
</script>

<style lang='less' scoped>
.indexList {
  width: 100%;
  padding: 24px 30px;
  box-sizing: border-box;
  background-color: #fff;

  .searchArea {
    display: flex;
    align-items: center;

    ::v-deep .el-select {
      margin-right: 20px;
    }

    ::v-deep .el-input__inner {
      width: 200px;
      height: 36px;
    }

    .date_picker {
      margin-right: 20px;

      .el-date-editor {
        width: 360px;
      }
    }

    ::v-deep .el-range-separator {
      display: flex;
      align-items: center;
      margin-right: 5px;
    }

    .input-with-select {
      width: 340px !important;

      ::v-deep .el-input__inner {
        width: 280px !important;
        margin-right: 0px !important;
      }

      .input-with-select {
        width: 340px !important;
      }
    }
  }
}

.allBtn {
  display: flex;
  right: 10px;
  top: 15px;
  margin-top: 20px;

  ::v-deep .el-button {
    padding: 8px 16px;
  }
}
</style>
